// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 8670) return "static/chunks/8670-9054ec8311a500a2b211.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"808":"8075f2841d5725fa4d94","4307":"90f80d430232564a48e2","5789":"c8915245fb68d6a2f9a9","9475":"089a6654ae697bdf320a"}[chunkId] + ".js";
};